"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sizeStyle = void 0;
var height = {
    sm: 'squid-h-component-button-height-sm',
    md: 'squid-h-component-button-height-md',
    lg: 'squid-h-component-button-height-lg',
};
var padding = {
    text: {
        sm: 'squid-px-component-button-sm-padding-base',
        md: 'squid-px-component-button-md-padding-base',
        lg: 'squid-px-component-button-lg-padding-base',
    },
    iconLeft: {
        sm: 'squid-pl-component-button-sm-padding-tight squid-pr-component-button-sm-padding-base',
        md: 'squid-pl-component-button-md-padding-tight squid-pr-component-button-md-padding-base',
        lg: 'squid-pl-component-button-lg-padding-tight squid-pr-component-button-lg-padding-base',
    },
    iconRight: {
        sm: 'squid-pl-component-button-sm-padding-base squid-pr-component-button-sm-padding-tight',
        md: 'squid-pl-component-button-md-padding-base squid-pr-component-button-md-padding-tight',
        lg: 'squid-pl-component-button-lg-padding-base squid-pr-component-button-lg-padding-tight',
    },
    icons: {
        sm: 'squid-px-component-button-sm-padding-tight',
        md: 'squid-px-component-button-md-padding-tight',
        lg: 'squid-px-component-button-lg-padding-tight',
    },
};
var sizeStyle = function (size, options) {
    var sizeClassKey = 'text';
    if (options && options.hasIcon) {
        if (options.position === 'both') {
            sizeClassKey = 'icons';
        }
        else {
            sizeClassKey = options.position === 'left' ? 'iconLeft' : 'iconRight';
        }
    }
    return [padding[sizeClassKey][size], height[size]];
};
exports.sizeStyle = sizeStyle;
